"use client"

import { DialogContent, DialogRoot } from "@/shared/ui/dialog"
import Delivery from "./Delivery"

const Mobile = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  return (
    <>
      <DialogRoot size="full" lazyMount open={open} trapFocus={false}>
        <DialogContent display="flex" flexDir="column">
          <Delivery onClose={onClose} />
        </DialogContent>
      </DialogRoot>
    </>
  )
}

export default Mobile
